import { isNumber, isObject, isString, some, toLower } from 'lodash';
import { DateTime } from 'luxon';

const BANNED_TIMEZONES = ['etc/utc', 'etc/universal', 'etc/zulu', 'utc', 'universal', 'zulu', 'etc/uct', 'uct'];

interface Entity {
    timezone?: string;
}

export default {
    notUtcTimezone(timezone: string) {
        const normalizedTimezone = toLower(timezone);
        if (some(BANNED_TIMEZONES, (t) => t === normalizedTimezone)) {
            throw new Error('UTC timezone is not allowed.');
        }
    },

    timezone(timezone: string) {
        if (!DateTime.now().setZone(timezone).isValid) {
            throw new Error('Unknown timezone identifier: ' + timezone);
        }
    },

    string(string: string) {
        if (!isString(string)) {
            throw new TypeError(`Expected to be a string. typeof is ${typeof string} instead.`);
        }
    },

    number(number: number) {
        if (!isNumber(number)) {
            throw new TypeError(`Expected a number: "${String(number)}"`);
        }
    },

    data(object: object) {
        if (!isObject(object)) {
            throw new TypeError('Expected the data to be an object.');
        }
    },

    sameTimezones<T = Entity>(entity1: T, entity2: T) {
        if ((entity1 as Entity).timezone !== (entity2 as Entity).timezone) {
            throw new Error('Entities are in different timezones.');
        }
    },
};
